import { useLocation } from 'react-router';

export default () => {
  const location = useLocation();

  // A custom hook that builds on useLocation to parse
  // the query string for you.
  return new URLSearchParams(location.search);
};
